import { CommonModule } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi, withJsonpSupport } from '@angular/common/http';
import { APP_INITIALIZER, NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { GoogleMapsModule } from '@angular/google-maps';
import { HammerModule } from '@angular/platform-browser';
import ScrollbarComponent from '@app/shared/common/scrollbar/scrollbar.component';
import EnableTwoFactorAuthenticationModalComponent
    from '@app/shared/layout/profile/my-settings/enable-two-factor-authentication-modal.component';
// Metronic
import { PerfectScrollbarModule } from '@craftsjs/perfect-scrollbar';
import AppBsModalModule from '@shared/common/appBsModal/app-bs-modal.module';
import { ServiceProxyModule } from '@shared/service-proxies/service-proxy.module';
import UtilsModule from '@shared/utils/utils.module';
import { IMaskModule } from 'angular-imask';
import { FileUploadModule } from 'ng2-file-upload';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { ModalModule } from 'ngx-bootstrap/modal';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { ImageCropperComponent } from 'ngx-image-cropper';
import { NgxSpinnerModule } from 'ngx-spinner';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { BadgeModule } from 'primeng/badge';
import { CheckboxModule } from 'primeng/checkbox';
import { ChipModule } from 'primeng/chip';
import { ChipsModule } from 'primeng/chips';
import { DropdownModule } from 'primeng/dropdown';
import { FileUploadModule as PrimeNgFileUploadModule } from 'primeng/fileupload';
import { FloatLabelModule } from 'primeng/floatlabel';
import { GalleriaModule } from 'primeng/galleria';
import { InputGroupModule } from 'primeng/inputgroup';
import { InputGroupAddonModule } from 'primeng/inputgroupaddon';
import { InputNumberModule } from 'primeng/inputnumber';
import { InputTextModule } from 'primeng/inputtext';
import { MultiSelectModule } from 'primeng/multiselect';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { PaginatorModule } from 'primeng/paginator';
import { ProgressBarModule } from 'primeng/progressbar';
import { RadioButtonModule } from 'primeng/radiobutton';
import { SelectButtonModule } from 'primeng/selectbutton';
import { SliderModule } from 'primeng/slider';
import { TableModule } from 'primeng/table';
import { TabViewModule } from 'primeng/tabview';

import CdnImagePipe from '../shared/common/pipes/cdn-image.pipe';
import { EmailPipe } from '../shared/common/pipes/email.pipe';
import OfferImageNamePipe from '../shared/common/pipes/offer-image-name.pipe';

import AdministrationEntityGroupComponent
    from './components/administration/administration-entity-group/administration-entity-group.component';
import ChangeProfilePictureModalModule from './components/administration/users/change-profile-picture-modal.module';
import ContactsFilterComponent from './main/contacts-filter/contacts-filter.component';
import AdvancedFiltersComponent from './main/master-filter/advanced-filters/advanced-filters.component';
import CascadeSelectionComponent from './main/master-filter/cascade-selection.component';
import CascadeSelectionLocationComponent
    from './main/master-filter/cascade-selection-location/cascade-selection-location.component';
import MasterFilterComponent from './main/master-filter/master-filter.component';
import RangeInputComponent from './main/master-filter/range-input/range-input.component';
import RangeSliderComponent from './main/master-filter/range-slider.component';
import SearchesFilterComponent from './main/searches-filter/searches-filter.component';
import ButtonComponent from './shared/button/button.component';
import AdCardComponent from './shared/common/ad-card/ad-card.component';
import AddButtonDropdownComponent from './shared/common/add-button-dropdown/add-button-dropdown.component';
import AppCommonModule from './shared/common/app-common.module';
import AppGuidelinesModule from './shared/common/app-guidelines.module';
import BreadcrumbComponent from './shared/common/breadcrumb/breadcrumb.component';
import ClientCardComponent from './shared/common/client-card/client-card.component';
import MatchLabelComponent from './shared/common/match/match-label/match-label.component';
import MatchCardComponent from './shared/common/match-card/match-card.component';
import PropertyCardExpandedComponent
    from './shared/common/property-card/property-card-expanded/property-card-expanded.component';
import PropertyCardSmallComponent
    from './shared/common/property-card/property-card-small/property-card-small.component';
import SessionTimeoutComponent from './shared/common/session-timeout/session-timeout.component';
import SessionTimeoutModalComponent from './shared/common/session-timeout/session-timeout-modal-component';
import SliderWithInputsComponent from './shared/common/slider-with-inputs/slider-with-inputs.component';
import StepperContainerComponent from './shared/common/stepper-container/stepper-container.component';
import SubheaderModule from './shared/common/sub-header/subheader.module';
import TaskComponent from './shared/common/task/task.component';
import GoogleMapComponent from './shared/google-map/google-map.component';
import FooterComponent from './shared/layout/footer.component';
import FooterSettingsMenuComponent from './shared/layout/footer-settings-menu/footer-settings-menu.component';
import AppHeaderModule from './shared/layout/header/app-header.module';
import AppHeaderUserMenuComponent from './shared/layout/header/app-header-user-menu.component';
import MenuSearchBarComponent from './shared/layout/nav/menu-search-bar/menu-search-bar.component';
import SideBarMenuComponent from './shared/layout/nav/side-bar-menu.component';
import SidebarComponent from './shared/layout/nav/sidebar.component';
import TopBarMenuComponent from './shared/layout/nav/top-bar-menu.component';
import NavigationComponent from './shared/layout/navigation/navigation.component';
import NotificationSettingsModalComponent from './shared/layout/notifications/notification-settings-modal.component';
import NotificationsComponent from './shared/layout/notifications/notifications.component';
import ChangePasswordModalComponent from './shared/layout/profile/change-password/change-password-modal.component';
import LinkAccountModalComponent from './shared/layout/profile/linked-accounts/link-account-modal.component';
import LinkedAccountService from './shared/layout/profile/linked-accounts/linked-account.service';
import LinkedAccountsModalComponent from './shared/layout/profile/linked-accounts/linked-accounts-modal.component';
import MySettingsModalComponent from './shared/layout/profile/my-settings/my-settings-modal.component';
import RecoveryCodesComponent from './shared/layout/profile/my-settings/recovery-codes.component';
import SmsVerificationModalComponent from './shared/layout/profile/my-settings/sms-verification-modal.component';
import VerifyCodeModalComponent from './shared/layout/profile/my-settings/verify-code-modal.component';
import ViewRecoveryCodesModalComponent from './shared/layout/profile/my-settings/view-recovery-codes-modal.component';
import CreateNewUserDelegationModalComponent
    from './shared/layout/profile/user-delegations/create-new-user-delegation-modal.component';
import UserDelegationsModalComponent from './shared/layout/profile/user-delegations/user-delegations-modal.component';
import DefaultBrandComponent from './shared/layout/themes/default/default-brand.component';
import DefaultLayoutComponent from './shared/layout/themes/default/default-layout.component';
import DefaultLogoComponent from './shared/layout/themes/default/default-logo.component';
import NotificationItemComponent from './shared/notification-item/notification-item.component';
import AppComponent from './app.component';
import AppRoutingModule from './app-routing.module';

function appInitializerFactory() {
    return () => {

        const url = new URL(location.href);
        const params = url.searchParams;

        if (params.has('t')) {
            params.delete('t');
            window.location.href = url.toString();
        }
    };
}

@NgModule({
    declarations: [
        AppComponent,
        DefaultLayoutComponent,
        SideBarMenuComponent,
        TopBarMenuComponent,
        FooterComponent,
        DefaultBrandComponent,
        SessionTimeoutModalComponent,
        SessionTimeoutComponent,
        MenuSearchBarComponent,
        DefaultLogoComponent,
        ChangePasswordModalComponent,
        LinkedAccountsModalComponent,
        LinkAccountModalComponent,
        UserDelegationsModalComponent,
        CreateNewUserDelegationModalComponent,
        SmsVerificationModalComponent,
        EnableTwoFactorAuthenticationModalComponent,
        MySettingsModalComponent,
        VerifyCodeModalComponent,
        ViewRecoveryCodesModalComponent,
        RecoveryCodesComponent,
        SidebarComponent,
        MasterFilterComponent,
        CascadeSelectionComponent,
        RangeSliderComponent,
        AdvancedFiltersComponent,
        RangeInputComponent,
        CascadeSelectionLocationComponent,
        ContactsFilterComponent,
        SearchesFilterComponent,
        NotificationsComponent,
        NotificationSettingsModalComponent,
    ],
    exports: [
        DefaultLayoutComponent,
        MasterFilterComponent,
        ContactsFilterComponent,
        SearchesFilterComponent,
    ],
    schemas: [NO_ERRORS_SCHEMA], imports: [CommonModule,
        AppHeaderModule,
        FormsModule,
        ModalModule.forRoot(),
        TooltipModule.forRoot(),
        TabsModule.forRoot(),
        BsDropdownModule.forRoot(),
        PopoverModule.forRoot(),
        BsDatepickerModule.forRoot(),
        FileUploadModule,
        AppRoutingModule,
        UtilsModule,
        AppCommonModule.forRoot(),
        ServiceProxyModule,
        TableModule,
        PaginatorModule,
        PrimeNgFileUploadModule,
        ProgressBarModule,
        PerfectScrollbarModule,
        IMaskModule,
        ImageCropperComponent,
        AutoCompleteModule,
        NgxSpinnerModule,
        AppBsModalModule,
        SubheaderModule,
        MatchCardComponent,
        MatchLabelComponent,
        ReactiveFormsModule,
        PropertyCardSmallComponent,
        PropertyCardExpandedComponent,
        SliderWithInputsComponent,
        ButtonComponent,
        TaskComponent,
        StepperContainerComponent,
        AdCardComponent,
        ClientCardComponent,
        AdministrationEntityGroupComponent,
        NavigationComponent,
        ChangeProfilePictureModalModule,
        BreadcrumbComponent,
        AppGuidelinesModule,
        AppHeaderUserMenuComponent,
        BadgeModule,
        InputTextModule,
        SliderModule,
        OverlayPanelModule,
        InputGroupModule,
        InputGroupAddonModule,
        ChipsModule,
        ChipModule,
        RadioButtonModule,
        CheckboxModule,
        InputNumberModule,
        DropdownModule,
        AddButtonDropdownComponent,
        SelectButtonModule,
        GoogleMapsModule,
        MultiSelectModule,
        GoogleMapComponent,
        GalleriaModule,
        FloatLabelModule,
        TabViewModule,
        CdnImagePipe,
        NotificationItemComponent,
        OfferImageNamePipe,
        EmailPipe,
        HammerModule,
        ScrollbarComponent,
        FooterSettingsMenuComponent], providers: [
        {
            provide: APP_INITIALIZER,
            useFactory: appInitializerFactory,
            multi: true,
        },
        LinkedAccountService,
        provideHttpClient(withInterceptorsFromDi(), withJsonpSupport()),
    ], 
})
class AppModule {
}

export default AppModule;
